<template lang="pug">
  div.wrap-module-payment.f.fh
    div.payment-content
      div(v-if="currentPage === 'cardRegistration'")
        div.mb28
          span.block.text-center.fz16.bold.mb12 クレジットカードのご登録
          span.block.text-center.fz14.mb12 カード決済でライセンスを購入します
          span.block.text-center.fz13.mb8 Healthcare Catalyst License：年額13,200円（内税）
          span.block.fz13 * 最初の１年目は無料でご利用いただけます。１年後のライセンスの更新日から引き落としが発生します。
        div.f.fc
          div.wrap-card.mb28
            //- vue-credit-card(:preview-enabled="true" v-model="creditCardForm" :card-types="cardTypes")
            div.custom-input-group
              span.label(for="card-number") カード番号
              div.input(id="card-number")
              //- hint="対応カード：Visa,Mastercard,American Express,Discover,Diners Club,JCB")
            v-text-field(label="名義"
              v-model="cardHolderName"
              :placeholder="isCreditCardInputMounted ? 'Taro Yamada' : ' '"
              dark color="#fff")
            div.f
              div.expiration.mr12
                div.custom-input-group
                  span.label(for="card-expiry") 有効期限
                  div.input(id="card-expiry")
              div.cvv
                div.custom-input-group
                  span.label(for="card-cvv") セキュリティーコード
                  div.input(id="card-cvv")
        div.f.flex-right.pr6.mb50
          v-btn(@click="onNext"
            :color="pallete.$active_color"
            :disabled="disableGoToConfirmation") 次へ
        div
          span.fz12.block.text-center.mb2 銀行振り込みによるお支払いを
          span.fz12.block.text-center ご希望の方は#[a(href="mailto:hcc.info@deportare.tech?subject=[HCC]学費の決済方法についての問合せ").here-link こちら]までお問い合わせください
      div(v-if="currentPage === 'confirmation'").wrap-confirmation
        div.mb28
          span.block.text-center.fz16.bold 内容確認
        div.f.fc.mb28
          div
            span.block.fz16.mb4 品名：Healthcare Catalyst License（1年間）
            span.block.fz16.mb4 料金：年額13,200円（内税）
            span.block.fz16 トライアル期間：１年間
        div.f.flex-right
          div.f.fm
            span(@click="currentPage = 'cardRegistration'").back.mr18.cursor-pointer 戻る
            v-btn(@click="startSubscription" :color="pallete.$active_color") 購入
    div.wrap-logout.f.fc
      span(@click="logout").fz14 ログアウト
    
    NowLoading(:show="isSaving")
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
.wrap-module-payment {
  width: 100%; height: 100vh;
  .payment-content {
    position: relative;
    margin: 0 auto;
    width: $base_width_percent;
    max-width: 320px;
    // max-width: $base_max_width_px;
    .wrap-card {
      width: 280px;
      .expiration {
        width: 60px;
      }
      .cvv {
        margin-left: 12px;
        width: 50%;
      }
    }
    .wrap-confirmation {
      width: 320px;
    }
    .back {
      color: $secondary_text_color;
    }
  }
  .wrap-logout {
    position: absolute;
    width: 100%;
    bottom: 32px;
    color: $active_color;
  }
}
</style>

<style lang="scss">
@import "@/scss/_variables.scss";
// override css in VueCreditCard

.custom-input-group {
  margin-bottom: 20px;
  .label {
    color: #fff !important;
    font-size: 12px;
  }
  .input {
    margin-bottom: 6px;
    height: 26px;
    border-bottom: 1px solid rgba(255,255,255,0.7);
  }
}

// .vcc-container {
//   max-width: $base_max_width_px;
//   margin: 0 auto;
//   .vcc-credit-card-preview {
//     width: 320px; height: 200px;
//     margin: 0 auto;
//     background: #121212;
//   }
//   .vcc-row:nth-child(2) {
//     display: none !important;
//   }
// }
</style>

<script>
// import database from '@/database'
import { stripeKey, api } from '@/components/utils/config'
const stripe = Stripe(stripeKey) // eslint-disable-line no-undef
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth, mapActions: mapActionsAuth } = createNamespacedHelpers('auth')
import VueCreditCard from '@fracto/vue-credit-card'
import NowLoading from '@/components/shared/NowLoading'

export default {
  components: {
    VueCreditCard, NowLoading
  },
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapStateAuth(['uid']),
    disableGoToConfirmation () {
      // const form = this.creditCardForm
      // return (form.holder && form.number && form.month && form.year && form.cvv) ? true : false
      return false
    }
  },
  data () {
    return {
      currentPage: 'cardRegistration',
      // creditCardForm: {
      //   holder: '', number: '', month: '', year: '', cvv: ''
      // },
      // for dev
      // creditCardForm: {
      //   holder: 'Ko Ishihara', number: '4242424242424242', month: '12', year: '2025', cvv: '424'
      // },
      // // currentPage: 'confirmation',
      // cardTypes: [
      //   // { regEx: /^4[0-9]{5}/ig, name: 'visa', icon: require('../assets/visa_icon.png') },
      //   // { regEx: /^5[1-5][0-9]{4}/ig, name: 'mastercard', icon: require('../assets/master_icon.png') }
      // ],
      customer: null,
      cardTokenId: null,
      isCreditCardInputMounted: false,
      // cardNumber: '',
      cardNumberError: 'カード番号をご確認ください',
      cardHolderName: '',
      // cardExpirationDate: '',
      cardExpirationDateError: '有効期限をご確認ください',
      // cardCvv: '',
      cardCvvError: 'CVVをご確認ください',
      isSaving: false, isValid: true
    }
  },
  mounted () {
    setTimeout(() => {
      const style = {
        base: {
          fontFamily: 'Helvetica',
          fontSize: '16px',
          color: 'white',
        }
      }

      const elements = stripe.elements({
        locale: 'ja',
      })

      // card-number
      this.cardNumberElement = elements.create('cardNumber', {
        style,
        placeholder: '0000 0000 0000 0000',
      })
      this.cardNumberElement.on('ready', () => {
        this.isCreditCardInputMounted = true
      })
      this.cardNumberElement.on('change', (data) => {
        let errorMessage = null
        if (data.empty) {
          errorMessage = 'カード番号をご確認ください'
        } else if (data.error) {
          errorMessage = data.error.message
        }
        this.cardTokenId = null
        this.cardNumberError = errorMessage
      })
      this.cardNumberElement.mount('#card-number')

      // card-expiry
      this.cardExpiryElement = elements.create('cardExpiry', {
        style,
        placeholder: 'mm/yy',
      })
      this.cardExpiryElement.on('change', (data) => {
        let errorMessage = null
        if (data.empty) {
          errorMessage = '有効期限をご確認ください'
        } else if (data.error) {
          errorMessage = data.error.message
        }
        this.cardTokenId = null
        this.cardExpirationDateError = errorMessage
      })
      this.cardExpiryElement.mount('#card-expiry')

      // card-cvc
      this.cardCvvElement = elements.create('cardCvc', {
        style,
        placeholder: '0000',
      })
      this.cardCvvElement.on('change', (data) => {
        let errorMessage = null
        if (data.empty) {
          errorMessage = 'CVVをご確認ください'
        } else if (data.error) {
          errorMessage = data.error.message
        }
        this.cardTokenId = null
        this.cardCvvError = errorMessage
      })
      this.cardCvvElement.mount('#card-cvv')
    }, 200)
  },
  methods: {
    ...mapActionsAuth(['signOut']),
    async onNext () {
      this.isSaving = true

      if (this.cardNumberError) {
        alert(this.cardNumberError)
        return
      }
      if (!this.cardHolderName) {
        alert('名義をご入力ください')
        return
      }
      if (this.cardExpirationDateError) {
        alert(this.cardExpirationDateError)
        return
      }
      if (this.cardCvvError) {
        alert(this.cardCvvError)
        return
      }

      const res = await fetch(`${api}/createCustomer`, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          user: this.user,
        })
      }).then(res => res)
      this.customer = await res.json()

      if (!this.cardTokenId) {
        const result = await stripe.createToken(this.cardNumberElement, {
          name: this.cardHolderName
        })
        .catch((error) => {
          this.isValid = false
          if (error['message']) {
            alert(error['message'])
          } else {
            alert('カードの情報をご確認ください')
          }
        })

        if (result) {
          this.cardTokenId = result.token.id
        }

        // const stripeToken = await requests
        //   .createCreditCardToken({
        //     cardNumber: this.cardNumber,
        //     cardHolderName: this.cardHolderName,
        //     cardExpMonth:
        //       this.cardExpirationDate[0] + this.cardExpirationDate[1],
        //     cardExpYear:
        //       this.cardExpirationDate[3] + this.cardExpirationDate[4],
        //     cardCvv: this.cardCvv
        //   })
        //   .catch((error) => {
        //     this.isValid = false
        //     if (error['code'] === 'invalid-argument' && error['message'] !== 'INTERNAL') {
        //       alert(error['message'])
        //     } else {
        //       alert('カードの情報をご確認ください')
        //     }
        //   })
        // if (stripeToken) {
        //   this.cardTokenId = stripeToken['id']
        // }

        if (!this.isValid) {
          this.isSaving = false
          return
        }
      }

      this.currentPage = 'confirmation'
      this.isSaving = false
    },
    async startSubscription () {
      this.isSaving = true

      const res = await fetch(`${api}/createSubscription`, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          user: this.user,
          customerId: this.customer.id,
          cardTokenId: this.cardTokenId
        })
      }).then(res => res)
      const subscription = await res.json()

      console.log('subscription:', subscription)
      this.isSaving = false

      alert('購入が完了しました！次にプロフィールを設定しましょう！')
      this.$router.push('/profile-edit')
      // paymentIsActiveはwebhookで更新している
    },
    async logout () {
      const letLogout = confirm('ログアウトしますか?')
      if (letLogout) {
        await this.signOut()
        this.$router.push('/sign-in')
      }
    }
  }
}
</script>
